import { IconProps } from "./types";
import React from "react";

export const PencilIcon = ({
  className,
  fill = "currentColor",
  width = 20,
  height = 20,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 20 20"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M4.0235 18.124H1.87506V15.9756L13.9899 3.83067L16.1684 6.00957L4.0235 18.124ZM16.6298 5.5459L14.4532 3.36934L15.6899 2.17168C15.8809 1.9795 16.1739 1.87403 16.4454 1.87403C16.579 1.87368 16.7114 1.8998 16.8349 1.95089C16.9584 2.00198 17.0706 2.07702 17.1649 2.17168L17.829 2.83575C17.9232 2.92998 17.9979 3.04193 18.0487 3.16515C18.0996 3.28837 18.1255 3.42043 18.1251 3.55371C18.1251 3.82715 18.0192 4.11817 17.8274 4.30996L16.6298 5.5459Z"
      fill={fill}
    />
  </svg>
);
